"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ProjectContext_1 = require("./contexts/ProjectContext");
const MainLayout_1 = __importDefault(require("./components/MainLayout"));
const Header_1 = __importDefault(require("./components/Header"));
const App = () => {
    return ((0, jsx_runtime_1.jsx)(ProjectContext_1.ProjectProvider, { children: (0, jsx_runtime_1.jsxs)("div", { className: "h-screen bg-gray-50 pt-12 overflow-hidden", children: [(0, jsx_runtime_1.jsx)(Header_1.default, {}), (0, jsx_runtime_1.jsx)(MainLayout_1.default, {})] }) }));
};
exports.default = App;
